<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        created() {
            console.log(window.location.host,'blhpc.kidcastle.cn')
            if(window.location.host.indexOf('blhpc.kidcastleapp.tw') > -1){
                this.$i18n.locale = 'zh_TW'
                this.$i18n.lang = 1
                localStorage.lang = 1
            }else{
                this.$i18n.locale = 'zh_CN'
                this.$i18n.lang = 0
                localStorage.lang = 0
            }

            let lang = localStorage.getItem('lang')
            this.$i18n.locale = lang?'zh_CN':'zh_TW'
            this.$i18n.lang = lang
            if(this.$i18n.lang == 0){
                document.title = '吉的堡百乐汇'
            }else{
                document.title = '吉的堡百樂匯'
            }
        }
    }
</script>

<style>
    *{
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        margin: 0;
        padding: 0;
    }
    ul,li{
        list-style-type: none;
    }
    div{
        color: #999999;
    }
    a{
        text-decoration:none;
        color:inherit;
    }
    input{
        outline: none;
        color: #606266;
    }
    input::-webkit-input-placeholder {
        color: #c0c4cc;
    }
    input:-moz-placeholder {
        color: #c0c4cc;
    }
    input::-moz-placeholder {
        color: #c0c4cc;
    }
    input:-ms-input-placeholder {
        color: #c0c4cc;
    }
    .el-input__prefix {
        width: 50px!important;
        display: flex!important;
        align-items: center!important;
        justify-content: center!important;
    }
    .el-input__inner{
        width: 240px!important;
        height: 40px!important;
        border-radius: 20px!important;
        border: 1px solid #EEEEEE!important;
        padding-left: 50px!important;
    }
    .el-checkbox__label{
        font-size: 12px!important;
        color: #999999!important;
    }
    .el-checkbox__inner{
        border-radius: 50%!important;
        margin-top: .5px!important;
    }
    .font14{
        font-size: 14px!important;
    }
    .font12{
        font-size: 12px!important;
    }
    .warning{
        width: auto;
        min-width: 240px;
        height: 58px!important;
        padding: 0 30px;
        background: url("./assets/img/warning_bg.png") no-repeat center center!important;
        background-size: 100% 85px!important;
        border: 0!important;
        box-shadow: unset!important;
        position: relative;
    }
    .warning .el-message-box__header,.warning .el-message-box__content{
        padding: 0!important;
    }
    .warning .el-message-box__content,.warning .el-message-box__message,.warning .el-message-box__message p{
        text-align: center;
        height: 58px;
        line-height: 58px;
        color: #FFFFFF;
        padding: 0 10px;
    }
    .warning .el-message-box__headerbtn{
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 999999;
    }
    .warning .el-message-box__headerbtn .el-message-box__close{
        color: #FFFFFF;
    }
    .complete{
        width: 240px!important;
        height: 58px!important;
        padding: 0!important;
        background: url("./assets/img/complete_bg.png") no-repeat center center!important;
        border: 0!important;
        box-shadow: unset!important;
        position: relative;
    }
    .complete .el-message-box__header,.complete .el-message-box__content{
        padding: 0!important;
    }
    .complete .el-message-box__content,.complete .el-message-box__message,.complete .el-message-box__message p{
        text-align: center;
        height: 58px;
        line-height: 58px;
        color: #FFFFFF;
    }
    .complete .el-message-box__headerbtn{
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 999999;
    }
    .complete .el-message-box__headerbtn .el-message-box__close{
        color: #FFFFFF;
    }
    .personal .el-form-item__label{
        color: red;
    }
    .personal .el-input__inner{
        padding-left: 20px!important;
    }
    .changeUserData .el-input__inner{
        padding-left: 20px!important;
    }
    .baby-radio .el-radio__inner{
        border-width: 3px;
    }
    .btn:focus, .btn:hover{
        background-color: transparent!important;
        border-color: transparent!important;
        color: #ffffff!important;
        opacity: 0.8;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px!important;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .el-tooltip__popper{
        border-color: #999999!important;
    }
    a:hover,.paly-icon:hover,.video-play-btn:hover,.play-btn img:hover,.play-title>div>div:hover,.upAndDown>div:hover,.nav-list li:hover,.list-box li:hover{
        opacity: 0.8;
        cursor: pointer;
    }
    .swiper-button-next:hover,.swiper-button-prev:hover{
        opacity: 0.8;
    }
    .changeUserData .el-input{
        width: auto!important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue